export default {
  methods: {
    tercError(field) {
      return !!field;
    }
  },
  computed: {
    isError: {
      get() {
        return !!(this.model && this.model.$warnings ? this.model.$error || this.model.$warnings.length : false);
      }
    }
  }
};
